import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import caretDown from '../../../../../img/caretDownGeneric.svg'
import styles from './styles.module.css'
import infoIcon from '../../images/circle-info-regular-full.svg'

const titleOptions = [
  { label: 'Individual', value: 'Individual' },
  { label: 'Company', value: 'Company' }
]

export default function CurrentOwnershipType ({
  localPeopleData,
  setLocalPeopleData
}) {
  return (
    <section className={styles.propertyTypeSection}>
      <div className={styles.sectionTitleWithIcon}>
        <h1 className={styles.titleSizeSection}>Current ownership type</h1>
        <Tooltip
          title='Filter by whether the property is owned by an individual or a company.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '.MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIcon}
            alt='Current ownership type help'
            width={14}
            height={14}
            className={styles.infoIcon}
            tabIndex={0}
          />
        </Tooltip>
      </div>

      <select
        name='currentOwnershipType'
        value={localPeopleData.currentOwnershipType}
        onChange={e =>
          setLocalPeopleData({
            ...localPeopleData,
            currentOwnershipType: e.target.value
          })
        }
        className={styles.selectSize}
      >

        <option value=''>Select</option>
        {titleOptions.map((opt, idx) => (
          <option key={idx} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      <img src={caretDown} alt='arrow' className={styles.customArrowPrice} />
    </section>
  )
}
